/**
 * This function allows for the throttling of a callback function. It'll run immediately and then every `delay`.
 * If the returned function is called within the delay then the args are saved and it'll get called after the delay with those saved args.
 * This function is useful when you have an event that is called hundreds of times (eg. scroll or resize events) and you don't want to run the callback every event.
 * @return [Function] The function that is throttled to only run every `delay`.
 * @link https://youtu.be/cjIswDCKgu0?t=416
 **/
export function getTrottledFunction(cb, delay = 1000) {
    let shouldWait = false;
    let waitingArgs;
    const timeoutFunc = () => {
        if (waitingArgs == null) {
            shouldWait = false;
        } else {
            cb(...waitingArgs);
            waitingArgs = null;
            setTimeout(timeoutFunc, delay);
        }
    }

    return (...args) => {
        if (shouldWait) {
            waitingArgs = args;
            return;
        }

        cb(...args);
        shouldWait = true;

        setTimeout(timeoutFunc, delay);
    }
};
